<template>
  <aside class="bg-gray-200">
    <NavigationMenu />
  </aside>
</template>

<script>
import NavigationMenu from '@/components/navigation/NavigationMenu';

export default {
  components: {
    NavigationMenu,
  },

};
</script>

<style scoped>
</style>
